import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=aa509fa8&"
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/renan/Fontes/OngFacil/Edital-Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa509fa8')) {
      api.createRecord('aa509fa8', component.options)
    } else {
      api.reload('aa509fa8', component.options)
    }
    module.hot.accept("./DoughnutChart.vue?vue&type=template&id=aa509fa8&", function () {
      api.rerender('aa509fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/charts/DoughnutChart.vue"
export default component.exports